import { render, staticRenderFns } from "./IndexValuesTable.vue?vue&type=template&id=58610366&scoped=true&"
import script from "./IndexValuesTable.vue?vue&type=script&lang=js&"
export * from "./IndexValuesTable.vue?vue&type=script&lang=js&"
import style0 from "./IndexValuesTable.vue?vue&type=style&index=0&id=58610366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58610366",
  null
  
)

export default component.exports